import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiMessage } from 'src/app/services/ai-audience-generation/ai-audience-generation.service';
import { TitanIconComponent } from 'src/app/user-interface/titan-icon/titan-icon.component';
import { MarkdownPipe } from 'src/app/pipes/markdown.pipe';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
  standalone: true,
  imports: [CommonModule, TitanIconComponent, MarkdownPipe]
})
export class ChatMessageComponent {
  @Input() message!: AiMessage;
  @Output() retry = new EventEmitter<string>();

  get isUser(): boolean {
    return this.message.role === 'user';
  }

  get isAssistant(): boolean {
    return this.message.role === 'assistant';
  }

  get isError(): boolean {
    return this.message.isError === true;
  }

  onRetryClick(): void {
    if (this.message.retryPrompt) {
      this.retry.emit(this.message.retryPrompt);
    }
  }
}
